import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import lastAlarm from "../../../assets/food/lastAlarm.gif"

const CountdownTimer = ({ duration, className, title, timerId, data, count, APIStatus }) => {
    const [showTimer, setShowTimer] = useState(false);
    const [isClosingTimer, setIsClosingTimer] = useState(false);
    const [timeLeft, setTimeLeft] = useState(duration);
    const [isRed, setIsRed] = useState(false);
    const [progress, setProgress] = useState(100);
    const [endTimeCount, setEndTimeCount] = useState(0);
    const [offerActivatedPage, setOfferActivatedPage] = useState(false);
    const [firstEndTime, setFirstEndTime] = useState(0);
    // console.log(duration)
    const navigate = useNavigate();
    const pathNames = location.pathname.split("/").filter(Boolean).pop();
    const pageName = localStorage.getItem("pageName");
    const theatreId = JSON.parse(localStorage.getItem("TheatreId"));
    const allOffers = JSON.parse(localStorage.getItem("storeAllOfferData") || []);
    const timerStorage = JSON.parse(localStorage.getItem("timers")) || {};

    const storeAllOfferData = pageName === "FBOptionPage"
        ? allOffers
        : allOffers.filter(item => item.theatreId === theatreId);

    const redTimer = JSON.parse(localStorage.getItem("redTimer") * 60) || [];

    const foundItem = pathNames?.includes("offeractivated")
        ? storeAllOfferData.find((item) => item.voucherNo === timerId)
        : storeAllOfferData.length > 0
            ? storeAllOfferData.reduce((earliest, current) => {
                return new Date(current.expiryDate) < new Date(earliest.expiryDate) ? current : earliest;
            }, storeAllOfferData[0])
            : null;

    const formatTime = (seconds) => {
        if (isNaN(seconds) || seconds < 0) return "00:00";
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
    };

    useEffect(() => {
        // Determine which timers to process
        const finalTimers = pathNames?.includes("offeractivated")
            ? foundItem ? [foundItem] : []
            : storeAllOfferData || [];

        if (finalTimers.length === 0) return;


        const currentTime = Date.now();
        // Group timers by theater
        const timersByTheater = finalTimers.reduce((acc, timer) => {
            const theaterId = timer.theatreId;
            if (!acc[theaterId]) acc[theaterId] = [];
            acc[theaterId].push(timer);
            return acc;
        }, {});

        // Check for expired timers in each theater
        const allTheatersExpired = Object.values(timersByTheater).every(theaterTimers =>
            theaterTimers.every(timer => new Date(timer.expiryDate).getTime() <= currentTime)
        );

        const specificTheaterExpired =
            theatreId && timersByTheater[theatreId] && timersByTheater[theatreId].every(timer => new Date(timer.expiryDate).getTime() <= currentTime);

        // let allTheatersExpired = true;
        // let specificTheaterExpired = false;
        const shouldShowModal = specificTheaterExpired || (!theatreId && allTheatersExpired);

        // const targetTheaterId = theatreId;
        // // Check if all timers in ALL theaters are expired
        // for (const theaterId in timersByTheater) {
        //     const hasActiveTimer = timersByTheater[theaterId].some(timer =>
        //         new Date(timer.expiryDate).getTime() > currentTime
        //     );

        //     if (hasActiveTimer) allTheatersExpired = false;

        //     if (theaterId == targetTheaterId) {
        //         specificTheaterExpired = !hasActiveTimer;
        //     }
        // }

        // // Handle all or specific theater expiry cases
        // if ((allTheatersExpired || (specificTheaterExpired && targetTheaterId)) && pathNames?.includes("offeractivated")) {
        //     const timer = setTimeout(() => {
        //         setShowTimer(true);
        //     }, 1000);
        //     return () => clearTimeout(timer);
        // }
        if (shouldShowModal && pathNames?.includes("offeractivated")) {
            const timer = setTimeout(() => {
                setShowTimer(true);
            }, 1000);
            return () => clearTimeout(timer);
        }
        // Sort timers by expiry (earliest first)
        const activeTimer = [...finalTimers]
            .sort((a, b) => new Date(a.expiryDate) - new Date(b.expiryDate))
            .find(timer => new Date(timer.expiryDate).getTime() > currentTime);

        if (!activeTimer) return;

        // Calculate timer values
        const expiryTime = new Date(activeTimer.expiryDate).getTime();
        const activatedTime = new Date(activeTimer.activatedDate).getTime();
        const totalDuration = Math.floor((expiryTime - activatedTime) / 1000);
        const initialTimeRemaining = Math.max(0, Math.floor((expiryTime - currentTime) / 1000));

        // Set initial state
        const isRed = initialTimeRemaining <= redTimer;
        setIsRed(isRed);
        setTimeLeft(initialTimeRemaining);
        setProgress(Math.min(Math.max((initialTimeRemaining / totalDuration) * 100, 0), 100));

        // Update localStorage
        localStorage.setItem("timers", JSON.stringify({
            ...timerStorage,
            [activeTimer.voucherNo]: {
                expiry: expiryTime,
                isRed,
            },
        }));

        // Set up interval for countdown
        const interval = setInterval(() => {
            setTimeLeft(prevTime => {
                const newTime = Math.max(0, prevTime - 1);
                setProgress(Math.min(Math.max((newTime / totalDuration) * 100, 0), 100));

                if (newTime === 0) {
                    clearInterval(interval);
                    localStorage.setItem("promBanner", false);
                    const updatedTimers = JSON.parse(localStorage.getItem("timers")) || {};
                    delete updatedTimers[activeTimer.voucherNo];
                    localStorage.setItem("timers", JSON.stringify(updatedTimers));
                    // if (APIStatus) {
                    //     setTimeout(() => {
                    //         APIStatus()
                    //     }, 1500);
                    // };
                }

                return newTime;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [storeAllOfferData, redTimer, foundItem, pathNames, APIStatus]);

    // Handle modal hide
    const handleHide = () => {
        setIsClosingTimer(false);
        console.log("false02")
        setShowTimer(false);
    };
    // Handle dismiss action
    const handleDismiss = async () => {
        // setShowTimer(false);
        // console.log("false01")
        // // localStorage.removeItem(`endTime_${timerId}`);

        // if (pathNames?.includes("food-Vouchers-at-boxoffice")) {
        //     try {
        //         await APIStatus?.(); // Optional chaining + await
        //     } catch (error) {
        //         console.error('Refresh failed, falling back to reload');
        //         window.location.reload();
        //     }
        // } else {
        //     navigate("/food-Vouchers-at-boxoffice");
        // }
        setShowTimer(false);

        const pageName = localStorage.getItem("pageName");
        const bckUrl = pageName === "FBOptionPage" ? "/?tab=food" : pageName === "offercart" ? "/foodcart" : "/food-Vouchers-at-boxoffice";
        navigate(bckUrl);
    };

    const handleOfferActivated = () => {
        localStorage.setItem("timerId", JSON.stringify(timerId))
        navigate("/offeractivated");
    }
    // && timerStorage[timerId]?.expiry > new Date().getTime()

    return (
        <>
            {pathNames?.includes("offeractivated") ? (
                <div className={`countTimer offerActivated ${className} ${isRed || timerStorage[timerId]?.expiry <= new Date() ? "red-timer" : ""}`}>
                    {storeAllOfferData?.length > 1 && count && <p className='bubbltag'>{storeAllOfferData?.length} active offer</p>}
                    <div className="countTimerinr">
                        <div className="timerTile">
                            <img src={lastAlarm} width={20} height={20} alt="" />
                            <span>{title}</span>
                        </div>
                        <p className='countDown'>{timerStorage[timerId]?.expiry <= new Date() ? "Expired" : `${formatTime(timeLeft)} Min`}</p>
                    </div>
                    <div className='timerbar'>
                        <div className='timerinrbar'
                            style={{
                                width: timerStorage[timerId]?.expiry <= new Date() ? "0%" : `${progress}%`,
                                transition: 'width 1s ease-in-out',
                            }}
                        />
                    </div>
                </div>
            ) : !pathNames?.includes("offeractivated") ? (
                <div onClick={handleOfferActivated} className={`countTimer ${className} ${isRed ? "red-timer" : ""}`}>
                    {storeAllOfferData?.length > 1 && count && <p className='bubbltag'>{storeAllOfferData?.length} active offer</p>}
                    <div className="countTimerinr">
                        <div className="timerTile">
                            <img src={lastAlarm} width={20} height={20} alt="" />
                            <span>{title}</span>
                        </div>
                        <p className='countDown'>{formatTime(timeLeft)} Min</p>
                    </div>
                    <div className='timerbar'>
                        <div className='timerinrbar'
                            style={{
                                width: `${progress}%`,
                                transition: 'width 1s ease-in-out',
                            }}
                        />
                    </div>
                </div>
            ) : ""}

            <Modal className='centerModal'
                show={showTimer || isClosingTimer}
                onHide={handleHide}
                animation={false}
                keyboard={false}
                dialogClassName={isClosingTimer ? "modal-dialog modal-hide" : "modal-dialog"}
                style={{ backgroundColor: "rgba(0,0,0,0.7)", overflow: "hidden" }}
            >
                <div className="modalbody">
                    <svg className='modaltimerIcon' width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 0.666992H6V2.00033H10V0.666992ZM7.33333 9.33366H8.66667V5.33366H7.33333V9.33366ZM12.6867 4.92699L13.6333 3.98033C13.3467 3.64033 13.0333 3.32033 12.6933 3.04033L11.7467 3.98699C10.7133 3.16033 9.41333 2.66699 8 2.66699C4.68667 2.66699 2 5.35366 2 8.66699C2 11.9803 4.68 14.667 8 14.667C11.32 14.667 14 11.9803 14 8.66699C14 7.25366 13.5067 5.95366 12.6867 4.92699ZM8 13.3337C5.42 13.3337 3.33333 11.247 3.33333 8.66699C3.33333 6.08699 5.42 4.00033 8 4.00033C10.58 4.00033 12.6667 6.08699 12.6667 8.66699C12.6667 11.247 10.58 13.3337 8 13.3337Z" fill="black" />
                    </svg>
                    <h3>Oops! Offer Time Expired</h3>
                    <p>Unfortunately, your offer time has expired. Please go to the offers page to activate it again</p>
                    <button className='modalbtn dismissbtn' onClick={handleDismiss}>Dismiss</button>
                </div>
            </Modal>
        </>
    );
};

export default CountdownTimer;
